export default "__VITE_ASSET__Dz2sIuW2__"